import axios from 'axios'
import tools from '@/utils/tools.js'
import { message } from '@/plugins/element.js'
import router from '../router'
import { openLoading, closeLoading } from '@/components/el-loading'
import VueRouter from 'vue-router'

const service = axios.create({
  baseURL: process.env.VUE_APP_SERVER_URL,
  timeout: 5 * 1000
})
// 请求拦截器
service.interceptors.request.use(config => {
  // 是否需要携带身份码
  if (tools.authorization()) {
    config.headers.Authorization = tools.authorization() // 每个请求都携带上
  }
  if (config.url !== '/dict/dict-industry-involved/list' && config.url !== '/path/api-url/listByRoleId') {
    openLoading()
  }
  return config
}, error => {
  closeLoading()
  return Promise.error(error)
})
// 请求响应器
service.interceptors.response.use(async res => {
// 未设置状态码则默认成功状态
  const status = res.data.status || 200
  // 捕获错误信息
  if (status === 401) {
    message.warning(`${res.data.message}`)
    sessionStorage.clear()
    setTimeout(function () {
    // 登录失效跳转 登录页面
      // window.location.href = '/web/userCenter'
    }, 1500)
  } else if (status === 403) {
    message.warning(`${res.data.message}`)
    closeLoading()
  } else if (status === 500) {
    message.warning(`${res.data.message}`)
    closeLoading()
  } else {
    setTimeout(function () {
      closeLoading()
    }, 300)
    return res
  }
}, error => {
  if (error.message.includes('timeout')) {
    message.warning('网络超时，请重新登录或刷新页面')
    closeLoading()
  }
  // 多个接口限制提示一次
  // if (document.getElementsByClassName('el-message').length === 0) {
  if (error.response.status === 404) {
    router.push('/404')
  } else if (error.response.data.status === 401) {
    message.warning(`${error.response.data.message}`)
    sessionStorage.clear()
    setTimeout(function () {
      console.log('VueRouter=========>', VueRouter)
      // 登录失效跳转 登录页面
      // window.location.href = '/web/userCenter'
    }, 1500)
  } else if (error.response.data.status === 403) {
    message.warning(`${error.response.data.message}`)
    closeLoading()
  } else if (error.response.status === 502) {
    message.warning('网络超时，请重新登录或刷新页面')
  }
  closeLoading()
  // }
  return Promise.error(error)
})
export default service
